import { wsService } from "./wsService";
const api_url = process.env.VUE_APP_API_URL;
const section = "packages";


function scan(param = {}) {  
  return wsService.make_post_request(section + "/scan", param);
}

function pack(param = {}) {  
  return wsService.make_post_request(section + "/pack", param);
}

function print_label_zpl(param = {}) {
  return wsService.make_post_request(section + "/print-label-zpl", param);
}

export const packagesService = {
  section,
  scan,
  pack,
  print_label_zpl,
};
